<template>
  <div class="contents_wrap" id="contents_wrap">
    <div class="small_title_wrap">
      <h2>{{ sendInfo.sendScnNm }} 정보</h2>
    </div>
    <div class="box_flex mgt10 mgb10">
      <button type="button" class="mid_btn mr5 f_l" @click="sampleDownload" >
        <span><span class="k-icon k-i-download"></span>해외 특송 샘플 파일</span>
      </button>
    </div>
    <kendo-grid
        id="sendBatchGrid"
        ref="sendBatchGrid"
        class="basic_table mgt10"
        style="cursor: pointer;"
        max-height="'100'"
        :navigatable="true"
        :filterable="false"
        :scrollable="true"
        :reorderable="true"
        :columns="sendBatchSaveColumns"
        :editable="true"
        :editable-mode="'inline'"
        :editable-confirmation="'해당 발송 정보를 삭제하시겠습니까?'"
        :selectable="'multiple row'"
        :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>Ctrl+V 를 이용해 붙여넣기 가능합니다.</div>' }"
    >
    </kendo-grid>
  </div>
</template>

<script>
import ApiConfig from "@/api/api.config";
import $ from "jquery";

export default {
  name: "SendBundleSaveExpr",
  props: {
    sendInfo: {
      type : Object,
      required : false,
    },
  },
  methods: {
    sampleDownload () {
      window.location = `${ApiConfig.eklDomain}/invariable/files/logistics_send_expr_excel_upload_form.xlsx`
    }
  },
  data () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    return {
      shpcScn: '05',
      sendBatchSaveColumns: [
        {
          field: 'No',
          title: 'No.',
          width: '3%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          sortable: false
        },
        {
          field: 'contentsScn',
          title: '내용',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'contentsDesc',
          title: '물품 내용 설명',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendFacility',
          title: '발신 사업장 / 거점 / 코스',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendBuilding',
          title: '발신 건물',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendFloor',
          title: '발신 층',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendZone',
          title: '발신 구역',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendNm',
          title: '발신',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendDept',
          title: '발신 부서',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendMailAddr',
          title: '발신 이메일',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendAmpmScn',
          title: '발신 시간',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'sendContents',
          title: '발신 비고',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveFacility',
          title: '수신 사업장 / 거점 / 코스',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveBuilding',
          title: '수신 건물',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveFloor',
          title: '수신 층',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveZone',
          title: '수신 구역',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveNm',
          title: '수신',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveDept',
          title: '수신 부서',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiMailAddr',
          title: '수신 이메일',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveAmpmScn',
          title: '수신 시간',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'receiveContents',
          title: '수신 비고',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          command: [
            {
              name:'destroy',
              className: "small_btn mr10",
              template: kendo.template(`<a class="small_btn k-grid-destroy mr10" style="height:24px;"><span class="k-icon k-i-trash"></span></a>`),
              click: function (e){
                e.preventDefault()
                let tr = $(e.target).closest('tr')
                let removeItem = this.dataItem(tr)

                vm.$refs.sendBatchGrid.kendoWidget().dataSource.remove(removeItem);
              },
            }
          ],
          width: '8%',
        }
      ],
    }
  },
}
</script>

<style scoped>

</style>